import { Box, Chip, Stack } from '@mui/material'

interface NoveltiesLanguagesCellProps {
  params: any
}

const NoveltiesLanguagesCell = ({ params }: NoveltiesLanguagesCellProps) => {
  const languages = params.row.languages || []
  if (!Array.isArray(languages)) return null

  const pairs = []
  for (let i = 0; i < languages.length; i += 2) {
    pairs.push(languages.slice(i, i + 2))
  }

  return (
    <Stack spacing={1}>
      {pairs.map((pair, index) => (
        <Box key={index} sx={{ display: 'flex', gap: 1 }}>
          {pair.map((lang: any) => (
            <Chip key={lang.code || Math.random()} label={(lang.code || '').toUpperCase()} size="small" sx={{ maxWidth: '100%' }} />
          ))}
        </Box>
      ))}
    </Stack>
  )
}

export default NoveltiesLanguagesCell
